import { useTranslation } from "react-i18next";

export default class APIService {

  // Get Connection Ratio
  static GetRatio(body, address) {
    console.log("Sending: " + JSON.stringify(body));
    return fetch(address, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        return data;
      })
      .catch((error) => console.log(error));
  }

  // Get Connection Report
  static GetReportComplete(body, address) {
    console.log("Sending: " + JSON.stringify(body));
    return fetch(address, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Report.docx";
        a.click();
      })
      .catch((err) => {
        return Promise.reject({ Error: useTranslation("SomethingWrong"), err });
      });
  }
}
